import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const ClapperBoardIcon: React.FC<OneColorIconProps> = ({ size = 32, color = '#F0FFFE', className }) => {
  const colorHex = getHexColor(color)
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M19.0023 12.0102H5.0181V18.2034L5.022 18.2834C5.04022 18.4693 5.12151 18.6427 5.25026 18.773C5.39679 18.9212 5.59286 19.0021 5.79457 19.0023H18.2258C18.4275 19.0022 18.6236 18.9212 18.7701 18.773C18.9172 18.6242 19.0022 18.4192 19.0023 18.2034V12.0102ZM4.49916 7.58364L4.3821 7.63339C4.1221 7.77971 3.92091 8.13431 4.02313 8.56299L4.46989 9.76768L8.3132 8.63615L6.67345 6.93009L4.49916 7.58364ZM8.82434 6.28532L10.4738 8.00016L12.9622 7.26759L11.2415 5.55958L8.82434 6.28532ZM17.3186 4.50804C17.2185 4.17005 16.8198 3.90213 16.3519 4.02714L13.4197 4.907L15.1492 6.6238L17.7303 5.86392L17.3186 4.50804ZM21 18.2034C20.9999 18.9411 20.7102 19.6513 20.1913 20.1767C19.6721 20.7023 18.9654 20.9999 18.2258 21H5.79457C5.05497 20.9999 4.34824 20.7023 3.82902 20.1767C3.37499 19.717 3.09654 19.1157 3.03402 18.4785L3.02036 18.2034V11.5293C3.00558 11.5064 2.98942 11.4843 2.97647 11.4601L2.92087 11.3362L2.12977 9.19996C2.11918 9.17136 2.10942 9.14163 2.10148 9.11217C1.71027 7.65928 2.47839 6.10923 3.91876 5.67176L15.8125 2.10453C17.2732 1.70122 18.8029 2.49743 19.2325 3.9335L19.9358 6.24825C20.0131 6.50309 19.9852 6.77861 19.8587 7.013C19.748 7.21809 19.5695 7.37677 19.3554 7.46366L19.2617 7.49683L10.7118 10.0125H20.0011C20.5528 10.0125 21 10.4597 21 11.0114V18.2034Z"
        fill={colorHex}
      />
    </svg>
  )
}
